import * as React from 'react'

export const SVG_ChevronDownSmall = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
        <g fill="#4F5B68" fillRule="evenodd">
            <path
                d="M4.486 7.082c.003.106.048.21.136.282l4.345 3.524c.159.13.395.105.525-.054s.105-.394-.054-.524L5.376 7.015 9.42 3.733c.16-.13.184-.365.054-.524-.13-.159-.366-.183-.525-.054L4.605 6.68c-.122.1-.164.26-.119.402"
                transform="translate(-20 -21) translate(1 1) translate(17 18) translate(2.478 2.478) rotate(-90 7.022 7.022)"
            />
        </g>
    </svg>
)
